<template>
  <b-icon-arrow-up-circle v-if="calculateWindowHeight" scale="2.5" class="arrow-go-top" @click="goTop"></b-icon-arrow-up-circle>
</template>

<script>
export default {
    data () {
        return {
            scTimer: 0,
            scY: 0
        }
    },
    computed: {
        calculateWindowHeight () {
            return this.scY > window.screen.height
        }
    },
    methods: {
        handleScroll () {
            if (this.scTimer) return
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY
                clearTimeout(this.scTimer)
                this.scTimer = 0
            }, 100)
        },
        goTop () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style lang="scss" scoped>
.arrow-go-top{
  position: fixed !important;
  display: block !important;
  top: 89vh !important;
  left: 5vw !important;
  z-index: 2 !important;
  color: $blue !important;
  cursor: pointer;
  @include media(mobile, tablets) {
    top: 87vh !important;
    left: 8vw !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ArrowUp.vue